/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board.reducer';

export const TumorBoardDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardEntity = useAppSelector(state => state.tumorBoard.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoard.detail.title">TumorBoard</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.description}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.createdById">Created By Id</Translate>
            </span>
            <UncontrolledTooltip target="createdById">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.createdById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.createdByType">Created By Type</Translate>
            </span>
          </dt>
          <dd>{tumorBoardEntity.createdByType}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.createdDate">Created Date</Translate>
            </span>
            <UncontrolledTooltip target="createdDate">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.createdDate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.createdDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoard.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoard.hospital">Hospital</Translate>
          </dt>
          <dd>{tumorBoardEntity.hospital ? tumorBoardEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board/${tumorBoardEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardDetail;
